<span class="pacote-campanha-label" [style.fontSize]="fontSize" title="Pacote da Campanha">
    <i class="fas fa-cubes"></i> {{nome}}
</span>